import { render, staticRenderFns } from "./VPic.vue?vue&type=template&id=2cc7a22f&scoped=true&"
import script from "./VPic.vue?vue&type=script&lang=js&"
export * from "./VPic.vue?vue&type=script&lang=js&"
import style0 from "./VPic.vue?vue&type=style&index=0&id=2cc7a22f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc7a22f",
  null
  
)

export default component.exports